import { IModelBanner } from '#adapter/api/campaigns/v6/active-banner/types';

export type TBannerType = IModelBanner['type'];

export const E_BANNER_TYPE: Record<string, TBannerType> = {
    PROMOTION: 'promotion',
    ALERT    : 'alert',
    ERROR    : 'error',
    SUCCESS  : 'success'
} as const;
